module.exports = __webpack_public_path__ + "img/history4.75c1034c.jpg";